import type { Vector3 } from '../vector/Vector3';

/** Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system */
export class Cylindrical {
  public radius: number;
  public theta: number;
  public y: number;

  constructor(radius?: number, theta?: number, y?: number) {
    this.radius = radius !== undefined ? radius : 1.0; // distance from the origin to a point in the x-z plane
    // counterclockwise angle in the x-z plane measured
    //  in radians from the positive z-axis
    this.theta = theta !== undefined ? theta : 0;
    this.y = y !== undefined ? y : 0; // height above the x-z plane

    return this;
  }

  public set(radius: number, theta: number, y: number): this {
    this.radius = radius;
    this.theta = theta;
    this.y = y;

    return this;
  }

  public clone(): Cylindrical {
    return new Cylindrical(this.radius, this.theta, this.y);
  }

  public copy(other: Cylindrical): this {
    this.radius = other.radius;
    this.theta = other.theta;
    this.y = other.y;

    return this;
  }

  public setFromVector3(v: Vector3): Cylindrical {
    return this.setFromCartesianCoords(v.x, v.y, v.z);
  }

  public setFromCartesianCoords(x: number, y: number, z: number): this {
    this.radius = Math.sqrt(x * x + z * z);
    this.theta = Math.atan2(x, z);
    this.y = y;

    return this;
  }
}
